
import { ContentsDocument } from '@platyplus/rxdb-hasura'
import { defineComponent, PropType, toRefs } from 'vue'

import { useRefFieldValue } from '../../../composables'
export default defineComponent({
  name: 'FieldReadDocument',
  props: {
    document: {
      type: Object as PropType<ContentsDocument>,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { name, document } = toRefs(props)
    const refDocument = useRefFieldValue<ContentsDocument>(document, name)
    return { refDocument }
  }
})
